<template>
  <dialog-v2
    :show="show"
    :title="title"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            v-model="form.name"
            v-validate="'required|max:100'"
            data-vv-name="name"
            data-vv-scope="survey"
            data-vv-as="nombre"
            label="Nombre"
            color="black"
            :error-messages="errors.collect('survey.name')"/>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <v-select
            v-model="form.voice"
            :items="voices"
            v-validate.disable="'required'"
            data-vv-scope="survey"
            data-vv-as="voz"
            data-vv-name="voice"
            label="Voz"
            color="black"
            :error-messages="errors.collect('survey.voice')"
            />
        </v-flex>
      </v-layout>

      <v-layout row wrap class="text-align-right" mb-4>
        <v-flex xs12>
          <v-switch
            label="Inbound "
            v-model="form.inbound"
            class="k-blue-linear-text"
            hint="Se usara para todas las llamadas inbound, solo puede haber una encuesta inbound activa"
            :persistent-hint="true"
          />
        </v-flex>
      </v-layout>

      <v-layout v-if="isBanamex" row wrap class="text-align-right" mb-4>
        <v-flex xs12>
          <v-switch
            label="Manuales"
            v-model="form.manual"
            class="k-blue-linear-text"
            hint="Se usara para todas las llamadas manuales, solo puede haber una encuesta manual activa"
            :persistent-hint="true"
          />
        </v-flex>
      </v-layout>
      <v-layout row wrap class="text-align-right" mb-4>
        <v-flex text-xs-right>
          <v-btn small depressed round class="k-orange-linear mr-0" @click="addQuestion">
            <v-icon small class="mr-1">
              fas fa-plus
            </v-icon>
            Agregar pregunta
          </v-btn>
        </v-flex>
      </v-layout>

      <draggable
        v-model="form.questions"
        class="draggable-list"
        ghost-class="ghost"
        handle=".handle"
        group="channels">
        <v-layout
          v-for="(question, index) in form.questions"
          :key="`question-${index}`"
          row
          wrap
          class="mb-3 d-flex align-center justify-space-between"
        >
          <v-flex md1 text-xs-center class="align-center">
            <v-icon small class="handle">
              fas fa-bars
            </v-icon>
          </v-flex>
          <v-flex md1 text-xs-center class="align-center">
            <div class="circle-container k-orange-linear">
              <span class="circle-number">
                {{ index + 1 }}
              </span>
            </div>
          </v-flex>
          <v-flex md5 pr-3>
            <v-text-field
              v-model="question.question"
              v-validate="'required'"
              :data-vv-name="'question_' + index"
              data-vv-scope="survey"
              data-vv-as="pregunta"
              label="Pregunta"
              color="black"
              :error-messages="errors.collect(`survey.question_${index}`)"
            />
          </v-flex>
          <v-flex md2 pr-3>
            <v-text-field
              v-model="question.min_value"
              v-validate="'required|numeric|min_value:0'"
              :data-vv-name="'question_min_' + index"
              data-vv-scope="survey"
              data-vv-as="valor mínimo"
              label="Mínimo"
              type="number"
              color="black"
              :error-messages="errors.collect(`survey.question_min_${index}`)"
              :disabled="!!question.id"
            />
          </v-flex>
          <v-flex md2>
            <v-text-field
              v-model="question.max_value"
              v-validate="'required|numeric|min_value:' + (Number(question.min_value) + 1)"
              :data-vv-name="'question_max_' + index"
              data-vv-scope="survey"
              data-vv-as="valor máximo"
              label="Máximo"
              type="number"
              color="black"
              :error-messages="errors.collect(`survey.question_max_${index}`)"
              :disabled="!!question.id"
            />
          </v-flex>
          <v-flex md1 class="text-xs-right">
            <v-btn
              icon
              flat
              round
              @click="deleteQuestion(index)"
              :disabled="form.questions.length === 1"
            >
              <v-icon small>fas fa-trash-alt</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </draggable>
    </template>
  </dialog-v2>
  </template>

  <script>
  import _ from 'lodash';
  import Draggable from 'vuedraggable';
  import DialogV2 from '@/components/global/DialogV2';

  export default {
    inject: ['$validator'],
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      survey: {
        type: Object,
        required: false,
      }
    },
    components: {
      DialogV2,
      Draggable,
    },
    data() {
      const emptyForm = {
        name: '',
        voice: '',
        inbound: false,
        manual: false,
        questions: [
          {
            id: undefined,
            question: '',
            min_value: '',
            max_value: ''
          }
        ]
      };
      return {
        emptyForm,
        form: _.cloneDeep(emptyForm),
        voices: [
          {
            text: 'Lupe',
            value: 'lupe',
          },
          {
            text: 'Ramiro',
            value: 'ramiro',
          },
        ],
      };
    },
    computed: {
      title() {
        let title;
        if (Object.keys(this.survey).length) {
          title = `Editar encuesta ${this.survey.name.toLowerCase()}`;
        } else {
          title = 'Crear encuesta';
        }
        return title;
      },
      isBanamex() {
        return Number(this.$auth.user().company_id) === 86496225;
      },
    },
    methods: {
      async save() {
        const validation = await this.$validator.validateAll('survey');
        if (!validation) {
          return;
        }

        var payload = _.cloneDeep(this.form);
        payload.questions = payload.questions.map(function (q, i) {
          return { question: q.question, min_value: q.min_value, max_value: q.max_value, order: i };
        });

        if (Object.keys(this.survey).length) {
          payload.questions = this.form.questions.map(function (q, i) {
            var mapped = { question: q.question, min_value: q.min_value, max_value: q.max_value, order: i };
            if (q.id) mapped.id = q.id;
            return mapped;
          });
          return this.axios.patch('surveys/' + this.survey.id, payload).then((response) => {
            this.$emit('updated', response.data);
          });
        }

        return this.axios.post('surveys', payload).then((response) => {
          this.$emit('created', response.data);
        });
      },
      clearErrors() {
        Object.keys(this.form).forEach((key) => {
          this.$validator.errors.remove(key, 'survey');
        });
      },
      addQuestion() {
        this.form.questions.push({
          id: undefined,
          question: '',
          min_value: '',
          max_value: ''
        });
      },
      deleteQuestion(index) {
        if (this.form.questions.length > 1) {
          this.form.questions.splice(index, 1);
        }
      },
    },
     watch: {
      show() {
        if (!this.show) {
          setTimeout(() => {
            this.form = _.cloneDeep(this.emptyForm);
            this.clearErrors();
          }, 200);
          return;
        }

        if (!Object.keys(this.survey).length) {
          return;
        }

        this.survey.questions = _.sortBy(this.survey.questions, 'order');
        this.form = _.cloneDeep(_.pick({
          ...this.emptyForm,
          ...this.survey,
          inbound: this.survey.inbound == 1 ? true : false,
          manual: this.survey.manual == 1 ? true : false,
        }, Object.keys(this.emptyForm)));
        this.clearErrors();
      }
    },
  };
</script>

<style scoped>
.circle-container {
  width: 30px;  /* Made smaller for better proportion */
  height: 30px;
  min-width: 30px; /* Prevent flex from squishing */
  min-height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-number {
  color: white;
  font-size: 16px;
  font-weight: bold;
  line-height: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/Surveys/Dialog.vue